<template>
  <router-view />
</template>

<script>
export default {
  name: 'User.CallStatistics'
}
</script>

<style scoped>

</style>
